export enum FeatureName {
  CVR_DEFAULT_DISCOUNT = 'cvr_default_discount',
}

export type AnonymousFeatures = typeof anonymousFeatures;
export type UserFeatures = typeof userFeatures;

export enum DefaultDiscountTreatments {
  off = 'off',
  control = 'control',
  discount20 = 'discount20',
  discount50 = 'discount50',
}

export const anonymousFeatures = {
  [FeatureName.CVR_DEFAULT_DISCOUNT]: {
    treatments: Object.values(DefaultDiscountTreatments),
    track: true,
    mock: {
      treatment: 'off',
      config: null,
    },
  },
};

export const userFeatures = {};
